import {LoadingItem, State} from "../reducers";
import {ErrorResponse} from "../types/StudioAPITypes";

/**
 * Check the loading state for selected actions
 *
 * @param {string[]} actions
 * @returns {(state: State) => boolean}
 */
export const createLoadingSelector = (actions: string[]) => (state: State) => {
  return actions.some((action: string) => {
    const loadingInfo: LoadingItem = state.loading[action];
    if (loadingInfo) {
      return loadingInfo.showLoader;
    }

    return false;
  })
};

/**
 * Create a selector that finds any loading state that is not excluded
 *
 * @param {string[]} excludedActions
 * @returns {(state: State) => boolean}
 */
export const createLoadingUnselector = (excludedActions: string[]) => (state: State) => {
  const remainingActions = [];
  for (const key in state.loading) {
    if (state.loading.hasOwnProperty(key) && excludedActions.indexOf(key) === -1) {
      const loadingInfo: LoadingItem = state.loading[key];
      if (loadingInfo.showLoader) {
        remainingActions.push(key);
      }
    }
  }

  return remainingActions.length > 0;
};

/**
 * Create a selector that finds the first non-401 error in the error state that is not excluded
 *
 * @param {string[]} excludedActions
 * @returns {(state: State) => (ErrorResponse | null)}
 */
export const createErrorUnselector = (excludedActions: string[]) => (state: State) => {
  let filteredActions: string[] = [];
  for (const key in state.error) {
    if (state.error.hasOwnProperty(key) && excludedActions.indexOf(key) === -1) {
      filteredActions.push(key);
    }
  }

  filteredActions = filteredActions.filter((action) => {
    if (!!state.error[action]) {
      const error: ErrorResponse = state.error[action];

      // Ignore 401 and 404 errors as they're handled separately
      return error.code !== 401 && error.code !== 404
    }
  });

  if (filteredActions.length > 0) {

    // Return the first error found for now
    return state.error[filteredActions[0]]
  }

  return null;
}
